import { createFileRoute } from '@tanstack/react-router';

import { assertUuidRouteParams } from '../../lib/assert-uuid-route-params.js';
import { TransferOrderDetailPage } from '../../modules/transfer-orders/transfer-order-detail-page.js';

export const Route = createFileRoute('/transfer-orders/$transferOrderId')({
  beforeLoad: ({ params }) => assertUuidRouteParams(params),
  component: TransferOrderDetailRoute,
});

// eslint-disable-next-line react-refresh/only-export-components -- route files export both Route and their page component; fast refresh flags the second export
function TransferOrderDetailRoute() {
  const { transferOrderId } = Route.useParams();
  return <TransferOrderDetailPage key={transferOrderId} transferOrderId={transferOrderId} />;
}
